import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrder } from "interfaces/SortOrder";
import { IPreferredConditionsMatchingHorseInfo } from "interfaces/PreferredConditionsMatchingHorsesSliderState";

const base = "PREFERRED_CONDITIONS_MATCHING_HORSES_SLIDER";

export const SET_IS_OPENED = `${base}_SET_IS_OPENED`;
export const SET_SELECTED_PREFERRED_CONDITIONS = `${base}_SET_SELECTED_PREFERRED_CONDITIONS`;
export const SET_ORDER = `${base}_SET_ORDER`;
export const SET_ORDER_BY = `${base}_SET_ORDER_BY`;
export const REMOVE_HORSE_ID = `${base}_REMOVE_HORSE_ID;`;

export interface PreferredConditionsMatchingHorsesSliderType {
  type: string;
  isOpened: boolean;
  selectedPreferredConditions: racehorse360.IHorsesCountGroupedByPreferredCondition;
  order: SortOrder;
  orderBy: keyof IPreferredConditionsMatchingHorseInfo;
  horseId: string;
}

export const setIsOpened = (
  isOpened: boolean
): Partial<PreferredConditionsMatchingHorsesSliderType> => {
  return {
    type: SET_IS_OPENED,
    isOpened
  };
};

export const setSelectedPreferredConditions = (
  selectedPreferredConditions: racehorse360.IHorsesCountGroupedByPreferredCondition
): Partial<PreferredConditionsMatchingHorsesSliderType> => {
  return {
    type: SET_SELECTED_PREFERRED_CONDITIONS,
    selectedPreferredConditions
  };
};

export const setOrder = (
  order: SortOrder
): Partial<PreferredConditionsMatchingHorsesSliderType> => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (
  orderBy: keyof IPreferredConditionsMatchingHorseInfo
): Partial<PreferredConditionsMatchingHorsesSliderType> => {
  return {
    type: SET_ORDER_BY,
    orderBy
  };
};

export const removeHorseIdFromSelectedPreferredConditions = (
  horseId: string
): Partial<PreferredConditionsMatchingHorsesSliderType> => {
  return {
    type: REMOVE_HORSE_ID,
    horseId
  };
};
